import React, { forwardRef } from "react";

const ReturnMedicinePrint = forwardRef(({ data }, ref) => {
  const items = data?.items || [];
  const subtotalAmount = items.reduce(
    (sum, item) => sum + Number(item?.total_price || 0),
    0
  );
  const discountAmount = Number(data?.discount || 0);
  
  // Debug: Log the data to see what's being received
  console.log('Print data:', data);
  console.log('Items:', items);

  return (
    <div ref={ref} style={{
      width: "80mm",
      fontFamily: "monospace",
      fontSize: "12px",
      lineHeight: "1.2",
      color: "#000",
      padding: "5mm"
    }}>
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <div style={{ fontWeight: "bold", fontSize: "14px" }}>Hospital Plus</div>
        <div style={{ fontSize: "10px" }}>Phone: +93 (0) 781968198</div>
        <div style={{ fontSize: "10px" }}>Address: Jalalabad city, Public Health, Farhang intersection, opposite the old medicine market</div>
        <div style={{ fontSize: "10px" }}>Main Road, Sari Month Directorate</div>
        <div style={{ borderBottom: "1px dashed #000", paddingBottom: "5px", marginTop: "5px" }}></div>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <div>Return ID: {data?.id}</div>
        <div>Type: Return Medicine</div>
        <div>Date: {data?.date}</div>
        <div>Total Price: {subtotalAmount.toFixed(2)} AFN</div>
        <div>Discount: {discountAmount.toFixed(2)} AFN</div>
        <div>Total Amount: {data?.total_amount} AFN</div>
      </div>

      <div style={{ borderTop: "1px dashed #000", paddingTop: "5px", marginBottom: "10px" }}>
        <div style={{ display: "flex", fontWeight: "bold", fontSize: "10px", borderBottom: "1px solid #000", paddingBottom: "2px", marginBottom: "5px" }}>
          <div style={{ width: "40%" }}>Medicine</div>
          <div style={{ width: "15%" }}>Qty</div>
          <div style={{ width: "20%" }}>Price</div>
          <div style={{ width: "25%" }}>Total</div>
        </div>
        {items.map((item, index) => (
          <div key={item.id || index} style={{ display: "flex", fontSize: "10px", marginBottom: "3px" }}>
            <div style={{ width: "40%" }}>{item.medicine_name || item.name}</div>
            <div style={{ width: "15%" }}>{item.quantity}</div>
            <div style={{ width: "20%" }}>{item.price}</div>
            <div style={{ width: "25%" }}>{item.total_price}</div>
          </div>
        ))}
      </div>

      <div style={{ borderTop: "1px dashed #000", paddingTop: "5px", textAlign: "center" }}>
        <div>Total Price: {subtotalAmount.toFixed(2)} AFN</div>
        <div>Discount: {discountAmount.toFixed(2)} AFN</div>
        <div style={{ fontWeight: "bold" }}>Total Amount: {data?.total_amount} AFN</div>
        <div style={{ fontSize: "10px", marginTop: "10px" }}>Thank you for choosing Hospital Plus!</div>
        <div style={{ fontSize: "10px" }}>Get well soon!</div>
        <div style={{ fontSize: "9px", marginTop: "10px" }}>Powered by Hospital Plus IT and Solution</div>
      </div>
    </div>
  );
});

export default ReturnMedicinePrint;
